export default {"src":"/_next/static/media/store-classic-solid.a5f72896.svg","height":24,"width":24};